/**
 * Returns whether a certain object is undefined
 * @param {*} object
 * @returns {Boolean}
 */
export function isUndefined(object) {
    return (typeof object) === "undefined";
};

/**
 * Returns whether a certain object is a Sting
 * @param {*} object
 * @returns {Boolean}
 */
export function isString(object) {
    return (typeof object) === "string";
};

/**
 * Returns whether a certain object is a boolean
 * @param {*} object
 * @returns {Boolean}
 */
export function isBoolean(object) {
    return (typeof object) === "boolean";
};

/**
 * Returns whether a certain object is a number
 * @param {*} object
 * @returns {Boolean}
 */
export function isNumber(object) {
    return (typeof object) === "number";
};

/**
 * Returns whether a certain object is null. Undefined is also considered null by this function.
 * @param {*} object
 * @returns {Boolean}
 */
export function isNull(object) {
    return object === null || (typeof object) === 'undefined';
};

/**
 * Returns whether a given object is an array
 * @param {*} object
 * @returns {Boolean}
 */
export function isArray(object) {
    return Object.prototype.toString.call(object) === '[object Array]';
};